import React from "react";
import Rice from "../images/Products/rice.jpg";
import FrozenMeat from "../images/Products/frozen-meat.jpg";
import WholeSpices from "../images/Products/whole-spices.jpg";
import { Link } from "react-router-dom";

const Frontpage = () => {
  return (
    <div className="frontpage">
      <section className="hero">
        <div className="hero-content">
          <h1>YOUR TRUSTED PARTNER IN PREMIUM WHOLESALE PRODUCTS</h1>
          <p>
            DELIVERING QUALITY FROZEN CHICKEN / BEEF & RICE WORLDWIDE FROM THE
            UAE
          </p>
          <Link to={"/products"}>
            {" "}
            <button className="primary-btn">VIEW OUR PRODUCTS</button>
          </Link>
        </div>
      </section>

      <section className="features">
        <div className="feature-box">
          <h3>Quality Assurance</h3>
          <p>Premium quality frozen products with strict quality control</p>
        </div>
        <div className="feature-box">
          <h3>Global Delivery</h3>
          <p>Worldwide shipping to 50+ countries with reliable logistics</p>
        </div>
        <div className="feature-box">
          <h3>Sustainability Commitment</h3>
          <p>Eco-friendly practices throughout our supply chain</p>
        </div>
      </section>

      <div className="product-section">
        <h2>Our Products</h2>
        <section className="products-preview">
          <div className="product-card">
            <img src={FrozenMeat} alt="Chicken Breast" />
            <h4>Frozen Meat</h4>
            <p>Premium quality frozen Meat</p>
            {/* <button className="secondary-btn">Explore Chicken Breasts</button> */}
          </div>
          <div className="product-card">
            <img src={WholeSpices} alt="Chicken Paws" />
            <h4>Whole Spices</h4>
            <p>High-quality frozen chicken paws</p>
            {/* <button className="secondary-btn">Explore Chicken Paws</button> */}
          </div>
          <div className="product-card">
            <img src={Rice} alt="Basmati Rice" />
            <h4>Premium Rice</h4>
            <p>Premium quality basmati rice varieties</p>
            {/* <button className="secondary-btn">Explore Basmati Rice</button> */}
          </div>
        </section>
      </div>

      <section className="delivery-section">
        <div className="delivery-content">
          <h2>Reliable Containerized Marine Delivery to 50+ Ports Globally</h2>
          <p>Efficient and reliable frozen food and logistics worldwide</p>
          <Link to={"/delivery"}>
            <button className="primary-btn">Check Our Delivery Routes</button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Frontpage;
